export const BASIC = "BASIC";
export const ADVANCED = "ADVANCED";

export const BASIC_SEARCH_LABEL = "Basic Search";
export const ADVANCED_SEARCH_LABEL = "Advanced Search";

export const NO_SEARCH_ATTRS =
  "No searchable attributes for selected entity types";

export const SEARCH_PLACEHOLDER = "Search...";
export const SEARCH_LABEL = "Search";

export const SELECT_SOME_ITEMS = "Select Some items...";
export const ALL_ITEMS_ARE_SELECTED = "All Items are Selected";
export const SELECT_ALL = "Select All";
export const SEARCH = "Search";
